/**
 * 后端如 ada_usdt_cfd、ADA/USDT -> 展示 ADA/USDT；基础币用于持仓数量后缀
 * @param {string} raw
 * @returns {{ pairLabel: string, baseCurrency: string }}
 */
export function formatAicopySymbolForDisplay(raw) {
  const s = String(raw ?? "").trim();
  if (!s) return { pairLabel: "", baseCurrency: "" };
  const normalized = s.replace(/\//g, "_").toLowerCase().replace(/_cfd$/i, "");
  const parts = normalized.split("_").filter(Boolean);
  const base = parts[0] ? parts[0].toUpperCase() : "";
  const quote = parts[1] ? parts[1].toUpperCase() : "";
  const pairLabel = base && quote ? `${base}/${quote}` : base || s.toUpperCase();
  return { pairLabel, baseCurrency: base };
}
